import { PropsWithChildren } from "react";
import { Control, Controller, FieldValues, Path, PathValue } from "react-hook-form";

import { SxProps, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

import { CommonFieldProps } from "./types";
import dayjs from "dayjs";

interface Props<T extends FieldValues> extends CommonFieldProps<T> {
    control: Control;
    label: string;
    sx?: SxProps;
    disabled?: boolean;
}

const FieldDatepicker: React.FunctionComponent<Props<any>> = <TObject extends FieldValues>({
    control,
    fieldName,
    label,
    sx = {},
    children,
    disabled = false,
}: PropsWithChildren<Props<TObject>>) => (
    // <Controller
    //     control={control}
    //     name={fieldName}
    //     defaultValue={null as PathValue<TObject, Path<TObject>>}
    //     render={({ field: {onChange, ..._field}, fieldState: { error } }) => (
    //         <DatePicker
    //             label={label}
    //             inputFormat='DD/MM/YYYY'
    //             renderInput={(params: any) => (
    //                 <TextField
    //                     {...params}
    //                     error={error ? true : false}
    //                     helperText={error ? error.message : null}
    //                 />
    //             )}
    //             onChange={(data) => onChange(data)}
    //             {..._field}
    //         />
    //     )}
    // />
    // <DatePicker
    //     slots={{ textField: TextField }}
    // />
    <Controller
        control={control}
        name={fieldName}
        defaultValue={null as PathValue<TObject, Path<TObject>>}
        render={({ field: { ref, onBlur, name, value, ...field }, fieldState: {error} }) => (
            <DatePicker
                {...field}
                inputRef={ref}
                label={label}
                disabled={disabled}
                sx={sx}
                value={typeof value === 'string' ? dayjs(new Date(value)).utc() : value}
                format='DD/MM/YYYY'
                // views={['day', 'month', 'year']}
                slots={{textField: TextField}}
                slotProps={{textField: {onBlur: onBlur, name: name, error: !!error, helperText: error?.message}}}
            />
        )}
    />
);

export default FieldDatepicker;